import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import AIIcon from "./AIIcon";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const ConsultantCommentaryCard = ({ theme, consultantCommentary }) => {
  return (
    <Card
      sx={{
        borderRadius: 3,
        boxShadow: "0 10px 25px rgba(15,23,42,0.12)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
          <TaskAltIcon sx={{ color: theme.palette.primary.main }} />
          <Tooltip
            title="Concise consultant narrative to accompany the trend."
            arrow
          >
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                fontSize: "0.95rem",
                color: theme.palette.primary.main,
                cursor: "help",
              }}
            >
              Consultant Commentary
            </Typography>
          </Tooltip>
          <AIIcon mode="light" />
          <DataSourceIcon mode="light" sources={["Salesforce", "Nasdaq"]} />
        </Box>

        {consultantCommentary.length > 0 ? (
          <List dense>
            {consultantCommentary.map((text, idx) => (
              <ListItem key={idx} sx={{ py: 0.3 }}>
                <ListItemIcon sx={{ minWidth: 26 }}>
                  <ArrowRightAltIcon
                    sx={{ fontSize: 16, color: theme.palette.primary.main }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={text}
                  primaryTypographyProps={{ fontSize: "0.8rem" }}
                />
              </ListItem>
            ))}
          </List>
        ) : (
          <Typography sx={{ fontSize: "0.8rem", color: "#6b7280" }}>
            —
          </Typography>
        )}
      </CardContent>
    </Card>
  );
};

export default ConsultantCommentaryCard;
